import { Typography } from "@mui/material"
import Config from "../../services/config"
import { EmptyProps } from "../../types/types"

export default function Empty(props: EmptyProps) {
    const { message = Config.NO_RESULTS_TEXT, variant = "body1", color = "secondary" } = props

    return (
        <Typography
            variant={variant}
            color={color}
            dangerouslySetInnerHTML={{ __html: message }}
        />
    )
}

